import { formatDistanceToNowStrict } from "date-fns";

export function formatDateTime(iso: string | null | undefined): string {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleString("en-GB", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function relativeAge(iso: string | null | undefined): string {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return formatDistanceToNowStrict(d, { addSuffix: true });
}

export type AgeLevel = "green" | "yellow" | "red" | "unknown";

export function ageLevel(iso: string | null | undefined): AgeLevel {
    if (!iso) return "unknown";
    const t = new Date(iso).getTime();
    if (Number.isNaN(t)) return "unknown";
    const minutes = (Date.now() - t) / 60_000;
    if (minutes < 15) return "green";
    if (minutes < 30) return "yellow";
    return "red";
}

export function oldestIso(isos: (string | null | undefined)[]): string | null {
    let oldest: string | null = null;
    for (const iso of isos) {
        if (!iso) continue;
        if (oldest === null || iso < oldest) oldest = iso;
    }
    return oldest;
}
